const generateDeviceId = (userId, perssistId, platform) => {

	if (perssistId) {

		const persistId = perssistId.match(/^([a-z0-9]+-\d+)/i);

		return `${persistId?.[1]}-${platform}`;

	}
	if (!perssistId) {

		const now = new Date();

		// Format tanggal dan waktu (YYYYMMDD-HHMMSS)
		const dateStr = now
			.toISOString()
			.replace(/[-:T.]/g, "")
			.slice(0, 15);

		return `${userId}-${dateStr}`;

	}
	return null;

};

export default generateDeviceId;
